<template>
    <div>
        <notification-panel-header :notification="notification">
        </notification-panel-header>

        <notification-comment :notification="notification" entityType="activity">
        </notification-comment>
    </div>
</template>

<script>
  import notificationPanelHeader from './notification-components/notification-panel-header'
  import notificationComment from './notification-components/notification-comment'

  export default {
    name: "notification-ActivityCommentMention",

    props: {
      notification: { type: Object, required: true }
    },

    components: {
      notificationPanelHeader,
      notificationComment
    },
  }
</script>

<style scoped>

</style>
